module.exports = __webpack_public_path__ + "static/img/gradient.b96d4e71.webp";